export const routes = [
  {
    path: '/v-configurazione',
    name: 'Configurazione',
    component: () => import(/* webpackChunkName: "configurazione" */ '../views/configurazione')
  }
]
